import type { ActivityIngredient } from '@apps/main/modules/recipe/ingredients';

import type { SelectedTicketInfo } from '@libs/trip-planner-interfaces';

import {
  ACTIVITY_PROPS_SEPARATOR,
  ACTIVITY_TICKETS_SEPARATOR,
  SELECTED_TICKET_PREFIX,
  TICKET_PROPS_SEPARATOR,
  TICKET_PROPS_WRAPPER_CLOSE,
  TICKET_PROPS_WRAPPER_OPEN,
} from './constants';

export function serializeActivity(activity: ActivityIngredient): string {
  const activityParameters = [
    activity.code,
    activity.selectedTicketDate !== undefined ? '' : activity.offset,
    serializeTickets(activity.tickets, activity.selectedTicketDate),
  ].join(ACTIVITY_PROPS_SEPARATOR);

  return `${SELECTED_TICKET_PREFIX}${activityParameters}`;
}

function serializeTickets(
  tickets: SelectedTicketInfo[],
  selectedTicketDate?: string
): string {
  return tickets
    .map((ticket) => {
      const ticketProps = [
        ticket.rateId ?? '',
        ticket.ageRangeId ?? '',
        ticket.getQuantityFromPax ? '' : String(ticket.quantity ?? ''),
        ticket.timeSlotId ? encodeURIComponent(ticket.timeSlotId) : '',
        ticket.getQuantityFromPax ? '1' : '0',
        selectedTicketDate ?? '',
      ];

      return `${TICKET_PROPS_WRAPPER_OPEN}${ticketProps.join(TICKET_PROPS_SEPARATOR)}${TICKET_PROPS_WRAPPER_CLOSE}`;
    })
    .join(ACTIVITY_TICKETS_SEPARATOR);
}
